
let endpoint = "/"; //processs.env.VUE_APP_API;


import Papa from "papaparse"
import axios from 'axios'; // Import Axios

// Your other functions and constants...

export const fetchVeilleCO2 = (callback, callbackError) => {
    axios.get("./static/veilleCO2/Veille-CO2.csv") // Use Axios instead of $http
        .then((response) => {
            Papa.parse(response.data.toString(), {
                header: true,
                complete: (results) => {
                    if (callback) {
                        callback(results);
                    } else { console.log("Default API Callback :", results.data) }
                }
            });
        })
        .catch((error) => {
            console.error("Default API Callback Error :", error);
            if (callbackError) callbackError(error)
        });
};


